"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { IMAGE_SERVER_URL, THEMED_ASSET_SERVER_URL } from '@autoguru/global-configs';
const sizes = [96, 128, /*256,*/384, 640, /*750,*/828, 1080 /* 1200, 1920, 2048, 3840,*/];
const isSvg = url => url.endsWith('.svg');
const sanitizedHexColor = hexColor => hexColor === null || hexColor === void 0 ? void 0 : hexColor.replace('#', '');
export const getThemedAssetSrc = ({
  url,
  colorReplacements: _colorReplacements = {}
}) => {
  const imageUrl = new URL(THEMED_ASSET_SERVER_URL);
  imageUrl.searchParams.set('url', url);
  if (!isSvg(url)) {
    throw new Error('A themed asset must be an svg');
  }
  for (const key of Object.keys(_colorReplacements)) {
    imageUrl.searchParams.append('cr', `${sanitizedHexColor(key)}:${sanitizedHexColor(_colorReplacements[key])}`);
  }
  return imageUrl.toString();
};
export const getImageServerSrc = ({
  url,
  width,
  quality: _quality = 60
}) => {
  if (isSvg(url)) return url;
  const imageUrl = new URL(IMAGE_SERVER_URL);
  imageUrl.searchParams.set('url', url);
  imageUrl.searchParams.set('w', width.toString());
  imageUrl.searchParams.set('q', _quality.toString());
  return imageUrl.toString();
};
export const getImageServerSrcset = ({
  url,
  quality
}) => sizes.reduce((concat, width) => `${concat}${getImageServerSrc({
  url,
  width,
  quality
})} ${width}w, `, '');